export default "__VITE_ASSET__Crei21Ka__"